import { definitions } from "../../schema/api";

const createShareResource = (): definitions["ShareResource"] => ({
  id: 0,
  parent_id: 0,
  client_id: 0,
  author_user_id: 0,
  type: "unknown",
  name: "",
  path: "",
  date: "",
  comment: "",
  content: "",
});

export { createShareResource };
